


























































import { defineComponent, computed, ref, watch } from '@vue/composition-api';
import { useClient } from '@/use';
import { Job } from '@/types';
import store from '@/store';

import { workerStatus as active } from '@/filemenu/admin/state';

export default defineComponent({
  name: 'WorkerStatus',
  setup() {
    const latestAddedTaskId = computed(() => store.state.application.latestAddedTaskId);
    const adminCheck = computed(() => store.getters.isAdmin);
    const headers = [
      { text: 'Job ID', value: 'id' },
      { text: 'User Name', value: 'kwargs.userinfo.user_name' },
      { text: 'Type', value: 'type' },
      { text: 'Video Name', value: 'video_name' },
      { text: 'Time Started', value: 'iso_time' },
      { text: 'Worker', value: 'worker_name' },
      { text: 'Status', value: 'status' },
      { text: 'Stop Job', value: 'stop_job' },
    ];

    const workersData = ref();
    const jobs = ref([] as Job[]);
    const activeJobs = ref();
    const queuedJobs = ref();
    const search = ref<string>('');
    const loading = ref<boolean>(true);

    const getWorkerStats = async () => {
      if (!adminCheck.value) {
        return;
      }
      loading.value = true;

      workersData.value = await useClient().getWorkerStatus();

      const filteredActiveJobs = Object.keys(workersData.value.active)
        .filter((key) => (!key.includes('annotation')) && (!key.includes('dev')))
        .reduce((obj, key) => Object.assign(obj, { [key]: workersData.value.active[key] }), {});

      activeJobs.value = Object.values(filteredActiveJobs).flat();
      activeJobs.value.map((job: Job) => Object.assign(job,
        { type: job.type.substring(job.type.indexOf('.') + 1) },
        // eslint-disable-next-line no-useless-escape
        { video_name: (job.args[0].filename as string).replace(/^.*(\\|\/|\:)/, '') },
        { iso_time: new Date(job.time_start * 1000).toISOString() },
        { worker_name: job.hostname.substring(job.hostname.indexOf('@') + 1) },
        { status: 'active' },
        { stop_job: false }));

      const filteredQueuedJobs = Object.keys(workersData.value.reserved)
        .filter((key) => (!key.includes('annotation')) && (!key.includes('dev')))
        .reduce((obj, key) => Object.assign(obj, { [key]: workersData.value.reserved[key] }), {});

      queuedJobs.value = Object.values(filteredQueuedJobs).flat();
      queuedJobs.value.map((element: Job) => Object.assign(element,
        { type: element.type.substring(element.type.indexOf('.') + 1) },
        // eslint-disable-next-line no-useless-escape
        { video_name: (element.args[0].filename as string).replace(/^.*(\\|\/|\:)/, '') },
        { iso_time: new Date(element.time_start * 1000).toISOString() },
        { worker_name: element.hostname.substring(element.hostname.indexOf('@') + 1) },
        { status: 'queued' },
        { stop_job: false }));

      loading.value = false;
    };

    const updateJobsList = async () => {
      if (activeJobs.value) {
        activeJobs.value.forEach((element: Job) => {
          jobs.value.push(element);
        });
      }

      if (queuedJobs.value) {
        queuedJobs.value.forEach((element: Job) => {
          jobs.value.push(element);
        });
      }
      jobs.value = [...new Map(jobs.value.map((item) => [item.id, item])).values()];
    };

    watch(workersData, () => {
      updateJobsList();
    }, { deep: true });

    getWorkerStats();

    // Update when new task added
    watch(latestAddedTaskId, () => {
      getWorkerStats();
    });

    const cancelJob = async (job: Job) => {
      const stopJob = await useClient().stopTask(job.id);
      if (stopJob) {
        const index = jobs.value.findIndex((element) => element.id === job.id);
        jobs.value[index].stop_job = true;
        jobs.value[index].status = 'stopped';
      }
    };

    return {
      active,
      headers,
      jobs,
      cancelJob,
      search,
      getWorkerStats,
      loading,
    };
  },
});

